<template>
  <header :class="isSP ? 'header--sp' : 'header--pc'" v-if="isDisplay">
    <v-img :class="isSP ? 'header__logo--sp' : 'header__logo--pc'" :src="require('@/assets/img/logo.jpeg')" contain />
    <a :class="isSP ? 'header__contact--sp' : 'header__contact--pc'"
       href="https://docs.google.com/forms/d/e/1FAIpQLScIFe15Xe2yv9fca1jOxHmr6ET-PgZTOxbBAhLliyeCHwaIuw/viewform"
       target="_blank">CONTACT</a>
  </header>
</template>

<script>
// ヘッダーを表示させないページ名
const NOT_DISPLAY = [
  'error',
  'notfound'
]

export default {
  computed: {
    /**
     * @return {Boolean} SPかどうか
     */
    isSP () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    },
    /**
     * @return {Boolean} ヘッダーを表示させるかどうか
     */
    isDisplay () {
      return !NOT_DISPLAY.includes(this.$route.name)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.header {
  position: fixed;
  top: 0;
  z-index: $header_zindex;
  display: flex;
  justify-content: space-between;
  width: 100vw;
  background-color: $white_color;
  &--sp {
    @extend .header;
    height: $header_height_sp;
    padding: 0 10px;
  }
  &--pc {
    @extend .header;
    height: $header_height_pc;
    padding: 0 40px;
  }
  &__logo {
    flex: initial;
    &--sp {
      @extend .header__logo;
      width: 115.91px;
    }
    &--pc {
      @extend .header__logo;
      width: 191px;
    }
  }
  &__contact {
    color: $black_color;
    &--sp {
      @extend .header__contact;
      font-size: 1.4rem;
      line-height: $header_height_sp;
    }
    &--pc {
      @extend .header__contact;
      font-size: 2.4rem;
      line-height: $header_height_pc;
    }
  }
}
</style>
